import {SET_DATES_COUNT,SHOW_MESSAGE,SET_INBOX_COUNT,EMAIL_READ,HIDE_MESSAGE,CONFIRM_ACTION,ACTION_CONFIRMED_OR_CANCELED} from './types';

export function showMessage(text)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:SHOW_MESSAGE,
                payload:text
            })
    }
}
export function emailRead()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:EMAIL_READ,
                payload:null
            })
    }
}
export function setInboxCount(messages)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:SET_INBOX_COUNT,
                payload:messages
            })
    }
}
export function setDatesCount(dates)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:SET_DATES_COUNT,
                payload:dates
            })
    }
}
export function showError(text)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:SHOW_MESSAGE,
                payload:text?text:"There has been an error processing your request, please refresh the page and try again."
            })
    }
}
export function hideMessage(text)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:HIDE_MESSAGE,
                payload:null
            })
    }
}
export function confirmAction(text,onConfirm,title,ok,cancel,onCancel=null,warning=false)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:CONFIRM_ACTION,
                payload:{title:title?title:"Confirm action",text:text?text:"Do you want to complete the action?",ok:ok?ok:"Yes",cancel:cancel?cancel:"No",onConfirm,onCancel,warning}
            })
    }
}
export function actionConfirmedOrCanceled()
{
    return function(dispatch)
    {
        dispatch(
            {
                type:ACTION_CONFIRMED_OR_CANCELED,
                payload:null
            })
    }
}